import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Agendas, AxiaFile,AxiaPetitionsRelationship } from 'src/app/model/agendas';
import { AuthService } from 'src/app/Services/AuthService/auth-service.service';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class EmailService {

  options: any;
  currentURL = '';
  currentClientURL ='';
  constructor(private http: HttpClient, private _authService: AuthService) {
    let headers = new HttpHeaders({
      'Content-Type': 'application/json'
    });
    this.options = { headers: headers };
    this.currentURL = window.location.origin.includes('localhost')? "": environment.BaseURL;
    this.currentClientURL = window.location.origin + (window.location.origin.includes('localhost')?  "" : environment.BaseClientURL)
  }

  sendEmailConfirmationEmail(_email: string, guid: string) {
    this.http.post<any>(this.currentURL + environment.SendEmail,
      { email: _email, url: this.currentClientURL + environment.UpdateAgentsConfirmEmail + guid }, this.options).subscribe(result => { });
  }

  SendUploadTransactionEmail(petitions: Agendas[], transactionsList: [], uploadedfilesList: [], filesToSendToAxia: string[], SelectedAxiaPetitionToUpload: string[] ) {
    return this.http.post<any>(this.currentURL + environment.SendUploadTransactionEmail,
      {
        agentCode: petitions[0].agentNum,
        agendas: petitions.map(x => x.agenda),
        agentName: petitions[0].agentName,
        transactionsList: transactionsList,
        filesList: uploadedfilesList,
        listOfFilestoSendToAxia: filesToSendToAxia,
        listOfPetitiostoSendToAxia: SelectedAxiaPetitionToUpload 
      }
      , this.options)
  }



  SendAxiaTransactionEmail(petitions: Agendas[], transactionsList: [], uploadedfilesList: [], filesToSendToAxia: string[], SelectedAxiaPetitionToUpload: string[] ) {
    return this.http.post<any>(this.currentURL + environment.SendAxiaTransactionEmail,
      {
        agentCode: petitions[0].agentNum,
        agendas: petitions.map(x => x.agenda),
        agentName: petitions[0].agentName,
        transactionsList: transactionsList,
        filesList: uploadedfilesList,
        listOfFilestoSendToAxia: filesToSendToAxia,
        listOfPetitiostoSendToAxia: SelectedAxiaPetitionToUpload 
      }
      , this.options)
  }
}
